import React, { useEffect, useRef } from "react";
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon";
import StructuredText from "../custom-structured-text-renderer";
import { graphql } from "gatsby";
import parse from "html-react-parser";
import Slider from "react-slick";
import BG from "../../../assets/images/greenwheat-bg.jpg";
import Burger from "../../../assets/images/bestburger.png";
import BoneIcons from "../../../assets/images/bone-icons.png";
import WoodsIcons from "../../../assets/images/woods-icons.webp";
import { Edlyn95Year, BoneAmbassadors,  } from "../../icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AnimationButton from "./animation-button";

gsap.registerPlugin(ScrollTrigger);

const RangeSliderItem = ({ items, title, richContent, button, theme, specialLogo, specialAlt, specialBorder, burger }) => {
  const rangeSliderRef = useRef(null);

  const settings = {
    className: "slider variable-width",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    fade: false,
    dots: false,
    centerMode: true,
    variableWidth: true,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 18000,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  useEffect(() => {
    const instance = rangeSliderRef.current;

    if (instance) {
      const items = instance.querySelectorAll(".range-slider-item__item");

      items.forEach((item, index) => {
        const timeline = gsap.timeline({
          scrollTrigger: {
            trigger: instance,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });

        timeline.fromTo(
          item,
          { yPercent: 100 },
          { yPercent: -100, ease: "none" }
        );

        const imageWrapper = item.querySelector(".gatsby-image-wrapper");
        if (imageWrapper) {
          timeline.fromTo(
            imageWrapper,
            { transform: "translate3d(0, -30%, 0)" },
            { transform: "translate3d(0, 30%, 0)", ease: "none" },
            0
          );
        }
      });
    }
  }, []);

  return (
    <section
      ref={rangeSliderRef}
      className={`range-slider-item range-slider-item--ambassadors ${theme}${specialLogo ? " special-logo" : ""}${specialAlt ? " special-alt" : ""}${
        specialBorder ? " special-border" : ""}${burger ? " burger" : ""}
      `}
    >
      {theme === "greenwheat" && (
        <div className="range-slider-item__bg">
          <img src={BG} alt="Greenwheat" />
        </div>
      )}
      <div className="range-slider-item__inner">
        {title && (
          <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            {parse(title)}
          </h2>
        )}
        <div className="range-slider-item__items">
          {theme !== "woods" && !specialLogo && !specialAlt && (
            <Slider {...settings}>
              {items?.length > 0 &&
                items.map((el, i) => (
                  <div key={i} className="range-slider-item__item">
                    {el.image && <Asset asset={el.image} />}
                  </div>
                ))}
            </Slider>
          )}
          {(theme === "woods" || specialLogo || specialAlt) &&
            items?.length > 0 &&
            items.map((el, i) => (
              <div key={i} className={`range-slider-item__item range-slider-item__item-${i}`}>
                <div data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                  {el.image && <Asset asset={el.image} />}
                </div>
                { burger && i === 0 &&
                  <div className="range-slider-item__burger">
                    <img src={WoodsIcons} alt="Burger Icon" />
                  </div>
                }
              </div>
            ))}
        </div>
        {(theme === "bone" && !specialLogo && !specialAlt) &&
          <div className="range-slider-item__items range-slider-item__items--ambassadors">
            {items?.length > 0 &&
              items.map((el, i) => (
                <div key={i} className={`range-slider-item__item range-slider-item__item-${i}`}>
                  <div data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                    {el.image && <Asset asset={el.image} />}
                  </div>
                  { i === 0 &&
                    <div className="range-slider-item__burger">
                      <img src={BoneIcons} alt="Bone Icons" />
                    </div>
                  }
                </div>
              ))}
          </div>
        }
        {richContent && (
          <div className="range-slider-item__text">
            <StructuredText data={richContent} />
          </div>
        )}
        {button?.length > 0 && (
          <AnimationButton
            className="btn btn--animation"
            to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink?.permalink}
          >
            {button[0].title}
          </AnimationButton>
        )}
      </div>
      {specialLogo && (
        <div className="range-slider-item__special-logo">
          <Edlyn95Year />
        </div>
      )}
    </section>
  );
};

export default RangeSliderItem;

export const query = graphql`
  fragment RangeSliderItemProps on DatoCmsRangeSliderItem {
    id
    title
    richContent {
      value
    }
    items {
      image {
        ...InternalAssetProps
      }
    }
    button {
      ...LinkWithTitleProps
    }
    specialLogo
    specialAlt
    specialBorder
    burger
  }
`;
